var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 2.66659C2.96482 2.66659 2.66634 2.96506 2.66634 3.33325V12.6666C2.66634 13.0348 2.96482 13.3333 3.33301 13.3333H12.6663C13.0345 13.3333 13.333 13.0348 13.333 12.6666V3.33325C13.333 2.96506 13.0345 2.66659 12.6663 2.66659H3.33301ZM1.33301 3.33325C1.33301 2.22868 2.22844 1.33325 3.33301 1.33325H12.6663C13.7709 1.33325 14.6663 2.22868 14.6663 3.33325V12.6666C14.6663 13.7712 13.7709 14.6666 12.6663 14.6666H3.33301C2.22844 14.6666 1.33301 13.7712 1.33301 12.6666V3.33325Z",
    fill: "rgb(36, 150, 255)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 5.99992C1.33301 5.63173 1.63148 5.33325 1.99967 5.33325H13.9997C14.3679 5.33325 14.6663 5.63173 14.6663 5.99992C14.6663 6.36811 14.3679 6.66658 13.9997 6.66658H1.99967C1.63148 6.66658 1.33301 6.36811 1.33301 5.99992Z",
    fill: "rgb(36, 150, 255)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99967 5.33325C6.36786 5.33325 6.66634 5.63173 6.66634 5.99992V13.9999C6.66634 14.3681 6.36786 14.6666 5.99967 14.6666C5.63148 14.6666 5.33301 14.3681 5.33301 13.9999V5.99992C5.33301 5.63173 5.63148 5.33325 5.99967 5.33325Z",
    fill: "rgb(36, 150, 255)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormBuilder);
export default __webpack_public_path__ + "static/media/form-builder.3661a38677f889333742be39aa4fcded.svg";
export { ForwardRef as ReactComponent };